import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Box } from 'components/Layout/Layout';

import Input from 'components/Input/Input';
import LoginView from 'components/LoginView/LoginView';
import Button from 'components/Button/Button';
import P from 'components/P/P';

import messages from './messages';
import { isEmailValid } from '../../utils/email';
import { useStores } from '../../store/useStores';

function ForgotLoginView() {
  const intl = useIntl();
  const { authStore } = useStores();

  const [username, setUsername] = useState('');
  const [resetSuccess, setResetSuccess] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = useCallback(
    async event => {
      event.preventDefault();
      await authStore.forgotPassword(username);
      setResetSuccess(true);
    },
    [authStore, username]
  );

  const title = intl.formatMessage(messages.forgotTitle);
  const message = intl.formatMessage(messages.forgotMessage);

  return (
    <LoginView title={title} message={message}>
      {resetSuccess && (
        <Box mb={10}>
          <P>
            <FormattedMessage {...messages.forgotSuccessMessage} />
          </P>
        </Box>
      )}
      {!resetSuccess && (
        <form onSubmit={handleSubmit}>
          <Box mb={20}>
            <Input
              placeholder={intl.formatMessage(messages.forgotEmail)}
              onChange={e => setUsername(e.target.value)}
              value={username}
              type="text"
            />
          </Box>
          <Button disabled={!username || !isEmailValid(username)} secondary>
            <FormattedMessage {...messages.forgotSubmitButton} />
          </Button>
        </form>
      )}
    </LoginView>
  );
}

export default observer(ForgotLoginView);
